import { MENU_ITEMS, type MenuItem } from './dockConfig'

interface Props {
  onMenuClick?: (item: MenuItem) => void
}

export default function MenuBarItems({ onMenuClick }: Props) {
  return (
    <>
      {MENU_ITEMS.map(item => (
        <button
          key={item}
          onClick={() => onMenuClick?.(item)}
          style={{
            padding: '2px 10px',
            background: 'transparent',
            border: 'none',
            color: 'var(--os-muted)',
            fontSize: '11px',
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'all 0.15s',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = 'var(--os-hover)'
            e.currentTarget.style.color = 'var(--os-text)'
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'transparent'
            e.currentTarget.style.color = 'var(--os-muted)'
          }}
        >
          {item}
        </button>
      ))}
    </>
  )
}
